import { INITIALIZE_HAAP, SET_FINANCING_MENU_STATE, SET_MOBILE_MENU_STATE } from '@Header/Navigation/ducks/types';

export const setFinancingMenuState = isFinancingExpanded => ({
  type: SET_FINANCING_MENU_STATE,
  payload: isFinancingExpanded
});

export const setMobileMenuState = isMobileMenuExpanded => ({
  type: SET_MOBILE_MENU_STATE,
  payload: isMobileMenuExpanded
});

export const initializeHaaP = skeletonState => ({
  type: INITIALIZE_HAAP,
  payload: skeletonState
});
